<template>
    <Layout class="bg-account">
        <Row type="flex" justify="center" align="middle" class="min-h-100vh py-5">
            <!-- eslint-disable-next-line vue/no-mutating-props -->
            <Col :xs="24" :md="22" :lg="20">
                <Card class="shadow">
                    <Row align="middle">
                        <Col :xs="24">
                            <h1 class="text-26">
                                ข้อกำหนดนโยบายการจัดเก็บข้อมูลส่วนบุคคล
                            </h1>
                            <!-- บทนำ -->
                            <div>
                                <h2 class="text-20">
                                    บทนำ
                                </h2>
                                <span class="pl-5">กรมประมงให้ความสำคัญกับการคุ้มครองข้อมูลส่วนบุคคลการล่วงละเมิดสิทธิในข้อมูลส่วนบุคคลการควบคุมการใช้ข้อมูลและการป้องกันการรั่วไหลของข้อมูลส่วนบุคคลจึงได้จัดทำนโยบายคุ้มครองข้อมูลส่วนบุคคลตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลขึ้นเพื่อให้เป็นผู้ควบคุมข้อมูลส่วนบุคคลและผู้ประมวลผลตามกฎหมายมีหน้าที่ และความรับผิดชอบตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 ให้การกำกับดูแลการประมวลผลข้อมูลส่วนบุคคลและมาตรการป้องกันคุ้มครองข้อมูลส่วนบุคคลรวมถึงการบริหารความเสี่ยงในการปฏิบัติหรืองดเว้นการปฏิบัติใด ๆ ที่เป็นการฝ่าฝืนกฎหมายเพื่อยึดถือเป็นแนวปฏิบัติอย่างเคร่งครัด กรมประมงให้ความสำคัญกับการคุ้มครองข้อมูลส่วนบุคคลการล่วงละเมิดสิทธิในข้อมูลส่วนบุคคลการควบคุมการใช้ข้อมูลและการป้องกันการรั่วไหลของข้อมูลส่วนบุคคลจึงได้จัดทำนโยบายคุ้มครองข้อมูลส่วนบุคคลตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลขึ้นเพื่อให้เป็นผู้ควบคุมข้อมูลส่วนบุคคลและผู้ประมวลผลตามกฎหมายมีหน้าที่ และความรับผิดชอบตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 ให้การกำกับดูแลการประมวลผลข้อมูลส่วนบุคคลและมาตรการป้องกันคุ้มครองข้อมูลส่วนบุคคลรวมถึงการบริหารความเสี่ยงในการปฏิบัติหรืองดเว้นการปฏิบัติใด ๆ ที่เป็นการฝ่าฝืนกฎหมายเพื่อยึดถือเป็นแนวปฏิบัติอย่างเคร่งครัด
                                </span>
                            </div>

                            <!-- การเปิดเผยข้อมูลส่วนบุคคล -->
                            <div class="mt-2">
                                <h2 class="text-20">
                                    การเปิดเผยข้อมูลส่วนบุคคล
                                </h2>
                                <ul>
                                    <li>
                                        กรมประมงจะไม่ยอมขายหรือเผยแพร่ข้อมูลส่วนตัวของท่านให้แก่บุคคลที่สามอื่นที่ไม่มีอำนาจหน้าที่ตามที่กฏหมาย
                                    </li>
                                    <li>
                                        การเปิดเผยข้อมูลจะเกิดขึ้นก็ต่อเมื่อท่านเป็นผู้ร้องขอและให้ความยินยอมให้เราดำเนินการให้หรือ การเปิดเผยข้อมูลนั้นเป็นไปตามที่กฎหมายอนุญาตหรือเป็นไปตามที่กฎหมายกำหนด อาทิ การเปิดเผยข้อมูลตามคำสั่งเจ้าหน้าที่ของรัฐซึ่งกฎหมายได้ให้อำนาจไว้ ตามคำสั่งศาล หรือตามหมายศาล
                                    </li>
                                    <li>
                                        เพื่อการพัฒนาและบำรุงรักษาระบบการของเราให้มีความปลอดภัยและมีประสิทธิภาพสูงสุด เราอาจทำความตกลงไว้กับบุคคลที่สามเพื่อให้ดำเนินงานกับเรา หรือดำเนินการในนามของเรา ทั้งนี้บุคคลที่สามนั้นจะต้องยอมรับข้อตกลงคุ้มครองข้อมูลส่วนตัวของท่านไว้เป็นความลับเช่นเดียวกัน
                                    </li>
                                </ul>
                            </div>

                            <!-- การเก็บรักษาข้อมูล -->
                            <div class="mt-2">
                                <h2 class="text-20">
                                    การเก็บรักษาข้อมูล
                                </h2>
                                <ul>
                                    <li>
                                        ระบบมีการจัดเก็บข้อมูลในลักษณะที่มีการเก็บจัดเก็บเป็น Soft Copy
                                    </li>
                                    <li>
                                        สถานที่จัดเก็บบนระบบคลาวด์กลางภาครัฐหรือ Government Data Center and Cloud service (GDCC) เป็นบริการของกระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม โดยสำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ (สดช.)ซึ่งดำเนินการร่วมกับบริษัท กสท โทรคมนาคม จำกัด (มหาชน)
                                    </li>
                                    <li>
                                        ระยะเวลาการเก็บรักษาข้อมูลส่วนบุคคล เป็นไปตามกฎหมาย/ประกาศ/ระเบียบที่กรมประมงกำหนด
                                    </li>
                                    <li>
                                        ท่านมีหน้าที่ปกป้องข้อมูลบนอุปกรณ์ของท่านเช่นการใช้โปรแกรมป้องกันไวรัส, การอัพเดตซอฟท์แวร์, เปลี่ยนรหัสผ่าน, และไม่ให้บุคคลที่สามเข้าถึงอุปกรณ์ของท่านได้ไม่ว่าทางใด
                                    </li>
                                </ul>
                            </div>


                            <!--มาตรการในการรักษาความปลอดภัย -->
                            <div class="mt-2">
                                <h2 class="text-20">
                                    มาตรการในการรักษาความปลอดภัย
                                </h2>
                                <span class="pl-5">กรมประมงให้ความสำคัญความปลอดภัยสูงสุดในการรักษาความลับของข้อมูลส่วนตัวและดำเนินการอย่างเข้มงวดเพื่อรักษาความปลอดภัยและป้องกันการนำข้อมูลของท่านโดยไม่ได้รับอนุญาตด้วยมาตรฐานขั้นสูง การรักษาความปลอดภัยที่ได้มาตรฐานสูงสุดของเรา ซึ่งรวมถึงเทคโนโลยีเข้ารหัสข้อมูลในระดับ 256 บิท (256-bit Encryption) ซึ่งเป็นการเข้ารหัสระดับสูงสุดของให้บริการมาตรฐานเดียวกับการทำธุรกรรมทางอินเทอร์เน็ต และมีการตรวจสอบปรับปรุงเทคโนโลยีรักษาความปลอดภัยสม่ำเสมอเพื่อให้ข้อมูลส่วนตัวของท่านได้รับการดูแลด้วยมาตรการรักษาความปลอดภัยสูงสุด
                                </span>
                            </div>

                            <!-- บทนิยาม -->
                            <div class="mt-2">
                                <h2 class="text-20">
                                    บทนิยาม
                                </h2>
                                <ul>
                                    <li>
                                        กฎหมายคุ้มครองข้อมูลส่วนบุคคล หมายถึง พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 และมีการแก้ไขเพิ่มเติมในอนาคต รวมตลอดถึงกฎเกณฑ์ต่างๆ ที่เกี่ยวข้อง
                                    </li>
                                    <li>
                                        ข้อมูลส่วนบุคคล หมายความว่า ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ
                                    </li>
                                    <li>
                                        ผู้ควบคุมข้อมูลส่วนบุคคล หมายความว่า บุคคลหรือนิติบุคคลซึ่งมีอำนาจหน้าที่ตัดสินใจเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
                                    </li>
                                    <li>
                                        ผู้ประมวลผลข้อมูลส่วนบุคคล หมายความว่า บุคคลหรือนิติบุคคลซึ่งดำเนินการเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งหรือในนามของผู้ควบคุมข้อมูลส่วนบุคคล ทั้งนี้ บุคคลหรือนิติบุคคลซึ่งดำเนินการดังกล่าวไม่เป็นผู้ควบคุมข้อมูลส่วนบุคคล
                                    </li>
                                    <li>
                                        เจ้าของข้อมูล หมายถึง บุคคลธรรมดาที่เป็นเจ้าของข้อมูลส่วนบุคคล ตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
                                    </li>
                                    <li>
                                        เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล หมายถึง เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล ตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
                                    </li>
                                </ul>
                            </div>

                            <!--วัตถุประสงค์ -->
                            <div class="mt-2">
                                <h2 class="text-20">
                                    วัตถุประสงค์
                                </h2>
                                <span class="pl-5">
                                    กรมประมงจะดำเนินการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน เพื่อประโยชน์ของท่านในการใช้งาน ผลิตภัณฑ์ หรือการขอรับบริการผ่านช่องทางอิเล็คทรอนิกส์ในรูปแบบ E-Service จากกรมประมงตลอดจนเพื่อปฏิบัติตามกฏหมายใดๆ ที่กรมประมงและท่านต้องปฏิบัติตาม และเพื่อวัตถุประสงค์อื่นใดตามที่ระบุในนโยบายฉบับนี้ ดังต่อไปนี้
                                </span>
                                <div class="pl-5">
                                    <ul>
                                        <li>
                                            จัดเก็บข้อมูลและไฟล์เอกสารส่วนบุคคลของท่านเพื่อการยืนยันตัวตนการเป็นสมาชิก
                                        </li>
                                        <li>
                                            ข้อมูลส่วนตัวของท่านที่จัดเก็บเพื่อวัตถุประสงค์ใดนอกจากให้บริการหรือเท่าที่ขอบข่ายกฎหมายกำหนด
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <!-- การประมวลผลข้อมูลส่วนบุคคล -->
                            <div class="mt-2">
                                <h2 class="text-20">
                                    การประมวลผลข้อมูลส่วนบุคคล
                                </h2>
                                <span class="pl-5">
                                    เมื่อได้รับข้อมูลส่วนบุคคลจากแหล่งที่มาของข้อมูลส่วนบุคคลแล้วเราจะดำเนินการกับข้อมูลส่วนบุคคลของท่าน ดังนี้
                                </span>
                            </div>
                            <div class="pl-5">
                                <ul>
                                    <li>
                                        เก็บรวบรวม
                                    </li>
                                    <li>
                                    	ใช้งานข้อมูล
                                    </li>
                                    <li>
                                        เปิดเผยข้อมูลตามที่ได้ร้องขอ ทั้งนี้ บุคคล หน่วยงาน ที่เราอาจเปิดเผยข้อมูลส่วนบุคคลของท่าน หากมีการร้องขอ ได้แก่
                                        <div class="pl-3">
                                            <ul>
                                                <li>
                                                    หน่วยงานราชการ
                                                </li>
                                                <li>
                                                    การปฏิบัติตามคำสั่งศาล
                                                </li>
                                                <li>
                                                    การปฏิบัติตามหน้าที่ตามที่บังคับกฏหมาย                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <!-- สิทธิ์ของเจ้าของข้อมูล -->
                            <div class="mt-2">
                                <h2 class="text-20">
                                    สิทธิ์ของเจ้าของข้อมูล
                                </h2>
                                <span class="mt-5">
                                     ท่านมีสิทธิ์ในการดำเนินการ ดังต่อไปนี้
                                </span>
                                <div>

                                    <ul>
                                        <li>
                                            สิทธิ์ในการเพิกถอนความยินยอม (right to withdraw consent): ท่านมีสิทธิ์ในการเพิกถอนความยินยอมในการ ประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมกับเราได้ ตลอดระยะเวลาที่ข้อมูลส่วนบุคคลของท่านอยู่กับเรา
                                        </li>
                                        <li>
                                            สิทธิ์ในการเข้าถึงข้อมูลส่วนบุคคล (right of access): ท่านมีสิทธิ์ในการเข้าถึงข้อมูลส่วนบุคคลของท่านและขอให้เรา ทำสำเนาข้อมูลส่วนบุคคลดังกล่าวให้แก่ท่าน รวมถึงขอให้เราเปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคลที่ท่านไม่ได้ให้ความ ยินยอมต่อเราได้
                                        </li>
                                        <li>
                                            สิทธิ์ในการแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง (right to rectification): ท่านมีสิทธิ์ในการขอให้เราแก้ไขข้อมูลที่ไม่ถูกต้อง หรือ เพิ่มเติมข้อมูลที่ไม่สมบูรณ์
                                        </li>
                                        <li>
                                            สิทธิ์ในการลบข้อมูลส่วนบุคคล (right to erasure): ท่านมีสิทธิ์ในการขอให้เราทำการลบข้อมูลของท่านด้วยเหตุบาง ประการได้
                                        </li>
                                        <li>
                                            สิทธิ์ในการระงับการใช้ข้อมูลส่วนบุคคล (right to restriction of processing): ท่านมีสิทธิ์ในการระงับการใช้ข้อมูล ส่วนบุคคลของท่านด้วยเหตุบางประการได้
                                        </li>
                                        <li>
                                            สิทธิ์ในการให้โอนย้ายข้อมูลส่วนบุคคล (right to data portability): ท่านมีสิทธิ์ในการโอนย้ายข้อมูลส่วนบุคคลของ ท่านที่ท่านให้ไว้กับเราไปยังผู้ควบคุมข้อมูลรายอื่น หรือ ตัวท่านเองด้วยเหตุบางประการได้
                                        </li>
                                        <li>
                                            สิทธิ์ในการคัดคานการประมวลผลข้อมูลส่วนบุคคล (right to object): ท่านมีสิทธิ์ในการคัดคานการประมวลผล ข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้ ท่านสามารถติดต่อมายังเจ้าหน้าที่ กองบริหารจัดการทรัพยากรและกำหนดมาตรการ กรมประมง เพื่อดำเนินการยื่นคำร้องขอดำเนินการตามสิทธิ์ข้างต้นได้ หรือ ท่านสามารถศึกษา รายละเอียดเงื่อนไข ขอยกเว้นการใช้สิทธิ์ต่างๆ โดยเราจะพิจารณาและแจ้งผลการพิจารณาตามคำร้องของท่านให้ทราบอีกครั้ง
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <!-- การเปลี่ยนแปลงนโยบายคุ้มครองข้อมูลส่วนบุคคล -->
                            <div class="mt-2">
                                <h2 class="text-20">
                                    การเปลี่ยนแปลงนโยบายคุ้มครองข้อมูลส่วนบุคคล
                                </h2>
                                <span class="pl-5">
                                    เราจะทำการพิจารณาทบทวนนโยบายความเป็นส่วนตัวเป็นประจำเพื่อให้สอดคลองกับแนวปฏิบัติ และ กฎหมาย ข้อบังคับที่เกี่ยวของ ทั้งนี้ หากมีการเปลี่ยนแปลงนโยบายความเป็นส่วนตัว เราจะแจ้งให้ท่านทราบด้วยการ update ข้อมูลให้ท่านทราบโดยเร็วที่สุด
                                </span>
                            </div>

                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </Layout>
</template>

<script>
    import { Card, Col, Layout, Row } from "ant-design-vue";
    import { defineComponent, reactive } from "vue";
    import { state as stateApp } from "../../../app.logic";
    import { isLoading, onClickBack } from "./pdpa.logic";

    export default defineComponent({
        components: {
            Card,
            Layout,
            Row,
            Col
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            viewOnly: { default: false }
        },
        setup(props) {
            const data = reactive({ rowProp: { gutter: 24 } });
            const refs = reactive({ form: null });
            return {
                props,
                data,
                refs,
                isLoading,
                onClickBack
            };
        }
    });
</script>

<style scoped>
    .bg-account {
        background-image: url("../../../assets/bg/bg-account.jpg");
        background-size: 100% 100%;
    }

    .card-item {
        text-align: center;
        width: 100%;
    }
</style>
